import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import HSort from "../canopia/HSort";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";
import Button from "react-bootstrap/esm/Button";
import React, {useEffect, useState} from "react";
import {diff, search2, sort} from "../canopia/CanopiaUtils";
import {FormGroup} from "react-bootstrap";
import {TiDeleteOutline} from "react-icons/ti";
import {PageSelector} from "../core/PageSelector";
import ajaxloader from "../../images/ajax-loader.gif";
import Btn from "../canopia/Btn";

export default function FundScanDetail(props) {

    const tgtDataOrig = props.tgtDataOrig;
    const showModal = props.show;
    const hideFunc = props.hideFunc;
    const loading = props.loading;
    const detailHeaders = props.detailHeaders;

    const initialSortStatus = {
        "name": "asc",
        "isin": "asc",
        "assetType": "asc",
        "lipperStatus": "asc",
        "level": "asc",
        "specialRating": "asc",
        "curAmName": "asc",
        "curSource": "asc",
        "curDateFmt": "asc",
        "prevDateFmt": "asc"
    }

    const SEARCH_PROPS = [
        "name",
        "isin",
        "assetType",
        "lipperStatus",
        "level",
        "specialRating",
        "curAmName",
        "curSource",
        "curDateFmt",
        "prevDateFmt"];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus, sortCol: "name",
    }

    const [myState, setMyState] = useState({
        tgtData: tgtDataOrig, // The displayed ones, filtered, sorted, ...

        ...sortAndFilterInitialState
    });

    // Pagination
    const PAGE_SIZE = 50;
    const [page, setPage] = useState(1);

    // Search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');
    const [showDiff, setShowDiff] = useState(false);

    const borderLeftClassName = 'border-left';
    const colSizeXL = 300;
    const colWidthXL = colSizeXL + 'px';
    const colSizeL = 122;
    const colWidthL = colSizeL + 'px';
    const colSizeM = 105;
    const colWidthM = colSizeM + 'px';
    const colSizeS = 55;
    const colWidthS = colSizeS + 'px';
    const padding = '0.55em 0.5em';

    useEffect(() => {
        // sortFunc(myState.sortCol);
        filter(showDiff, searchString);
    }, [tgtDataOrig]);

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function changePage(page) {
        setPage(page.key);
    }

    function filter(showDiff, searchString) {
        let newData = [...tgtDataOrig];

        if (showDiff) {
            // Keep only different look-through dates
            newData = diff(newData,
                ["curDateFmt"],
                ["prevDateFmt"]
            );
        }

        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState = {...myState, tgtData: newData};

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(showDiff, searchString);
    }

    function handleShowDifferencesOnly(show) {
        filter(show, searchString);
        setShowDiff(show);
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search..."
               className={'form-control float-left'}
               style={{minWidth: "280px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
            {searchCategoryInput}
        </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <TiDeleteOutline size={"1.4em"} className={"canopia2"}/>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    let rows;
    let effPage = page;
    let tgtData = myState.tgtData;

    if (tgtData && tgtData.length > 0) {

        let startIndex = (effPage - 1) * PAGE_SIZE;
        if (startIndex >= tgtData.length) {
            effPage = 1;
            startIndex = (effPage - 1) * PAGE_SIZE;
        }
        const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);
        rows = tgtDataAtPage.map(item => {
            let curDateFmt = item.curDateFmt;
            let prevDateFmt = item.prevDateFmt;
            let rowClass = '';
            if (curDateFmt && prevDateFmt && curDateFmt !== prevDateFmt) {
                rowClass = 'fund-scan-detail';
            }
            return <div key={item.isin} className={"flex-nowrap border-top " + rowClass}>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={item.name} maxSize={80} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={item.isin} maxSize={50} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={item.assetType} maxSize={50} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    <NameTruncWithSearch name={item.lipperStatus} maxSize={50}
                                         search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthS, padding: padding}}>
                    {item.level}
                </div>

                {/* Current */}
                <div className={"setup-col " + borderLeftClassName}
                     style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={item.specialRating} maxSize={50}
                                         search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={item.curAmName} maxSize={50} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={item.curSource} maxSize={50} search={searchString}
                                         wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    {curDateFmt}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    {prevDateFmt}
                </div>
            </div>;
        });
    }

    const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                       clickFunc={changePage}/>;

    return <Modal
        show={showModal}
        onHide={hideFunc}
        backdrop="static"
        keyboard={true}
        fullscreen={true}
        aria-labelledby="terms-and-conditions"
        scrollable={true}
    >
        <Modal.Body>
            {loading ? <div style={{margin: "1rem auto"}}>
                <img alt="loading" src={ajaxloader}/>
            </div> : <>
                <span className={'client-title'}>
                    {detailHeaders && <>{detailHeaders.clientName} ({detailHeaders.clientId})</>}
                </span>
                <div className={'border-top background-light'} style={{marginTop: "2rem"}}>
                    <div className={"flex-nowrap"}>
                        <div className={"setup-th"} style={{flexBasis: "250px"}}>
                            {pageSelector}
                        </div>
                        <div className={"setup-th-input"} style={{flexBasis: "250px"}}>
                            <div>{searchCategoryComp}</div>
                        </div>
                        <div className={"setup-th"}>
                            <Btn label={'Different Only'}
                                 curClass={showDiff ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                                 clickFunction={handleShowDifferencesOnly}
                                 btnValue={showDiff}
                                 doNotTranslate={true}/>
                        </div>
                    </div>
                </div>
                <div className={'border-top background-light'}>
                    <div className={"flex-nowrap"}>
                        <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                            <HSort label={<b>Name</b>} colName={'name'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>ISIN</b>} colName={'isin'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Asset Type</b>} colName={'assetType'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                            <HSort label={<b>Status</b>} colName={'lipperStatus'} state={myState}
                                   sortFunc={sortFunc} showLegend={true}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthS}}>
                            <HSort label={<b>Lvl</b>} colName={'level'} state={myState} sortFunc={sortFunc}
                                   showLegend={true}/>
                        </div>

                        {/* Current */}
                        <div className={"setup-th " + borderLeftClassName} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Spec. Hand.</b>} colName={'specialRating'} state={myState}
                                   sortFunc={sortFunc} showLegend={true}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>AM</b>} colName={'curAmName'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Source</b>} colName={'curSource'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                            <HSort label={<b>Date</b>} colName={'curDateFmt'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                            <HSort label={<b>Prev Date</b>} colName={'prevDateFmt'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                    </div>
                </div>
                {rows}
            </>}

        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => hideFunc()}>
                {'Close'}
            </Button>
        </Modal.Footer>
    </Modal>
}

FundScanDetail.propTypes = {
    tgtDataOrig: PropTypes.arrayOf(PropTypes.any).isRequired,
    show: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    hideFunc: PropTypes.func.isRequired
}